import * as React from 'react';
import { createComponent } from '@lit/react';
import { CarouselWC } from './carousel.wc';
// import {
//   GenerateComponentTypeWithChildren,
//   GeneratePropsWithRef,
// } from '../component-types-generics';

// export type StepperProps = GenerateComponentTypeWithChildren<StepperWC>;

// export type StepperPropsWithRef = GeneratePropsWithRef<StepperProps>;

export const Carousel = createComponent<CarouselWC>({
  tagName: CarouselWC.tagname,
  elementClass: CarouselWC,
  react: React,
});
